import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// SPLIT-mode layout: a Stage (shared screen or pinned feeds) beside/above a
// Feed strip. Orientation is chosen by comparing aspect ratios; the stage is
// maximized first (keeping its aspect exactly) while reserving room for the
// feed strip, then the stage+strip group is centered in the container.

import { DEFAULT_GAP, MIN_FEED_AREA_HEIGHT, MIN_FEED_AREA_WIDTH, fitAspectInBox } from './types';
import { placeFeedGrid, planContentSize, planFeedGrid } from './feed-grid';
var emptyFeedGrid = function emptyFeedGrid() {
  return {
    cols: 0,
    rows: 0,
    tileWidth: 0,
    tileHeight: 0,
    tileAspect: 16 / 9,
    visibleCount: 0,
    overflowCount: 0,
    tiles: []
  };
};
export var computeSplitLayout = function computeSplitLayout(container, stageAspect, feedCount) {
  var _options$gap;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var gap = (_options$gap = options.gap) !== null && _options$gap !== void 0 ? _options$gap : DEFAULT_GAP;
  var maxVisible = options.maxVisible,
    minWidth = options.minWidth;
  var containerAspect = container.width / container.height;
  // Equality resolves to HORIZONTAL by convention.
  var orientation = containerAspect >= stageAspect ? 'HORIZONTAL' : 'VERTICAL';

  // No other feeds: the stage simply maximizes within the whole container.
  if (feedCount <= 0) {
    var size = fitAspectInBox(container.width, container.height, stageAspect);
    return {
      orientation: orientation,
      stage: {
        x: (container.width - size.width) / 2,
        y: (container.height - size.height) / 2,
        width: size.width,
        height: size.height
      },
      feedArea: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      },
      feedGrid: emptyFeedGrid()
    };
  }
  if (orientation === 'HORIZONTAL') {
    // Maximize the stage in (container width - reserved strip), full height.
    var stageBoxWidth = Math.max(1, container.width - MIN_FEED_AREA_WIDTH - gap);
    var _stage = fitAspectInBox(stageBoxWidth, container.height, stageAspect);

    // The strip gets the leftover width; size its grid, then tighten to the
    // grid's actual content width so the group can be centered.
    var leftoverWidth = container.width - _stage.width - gap;
    var _plan = planFeedGrid({
      width: leftoverWidth,
      height: container.height
    }, feedCount, {
      gap: gap,
      maxVisible: maxVisible,
      minWidth: minWidth
    });
    var _content = planContentSize(_plan, gap);
    var stripWidth = Math.max(_content.width, MIN_FEED_AREA_WIDTH);
    var groupWidth = _stage.width + gap + stripWidth;
    var groupX = Math.max(0, (container.width - groupWidth) / 2);
    var _stageRect = {
      x: groupX,
      y: (container.height - _stage.height) / 2,
      width: _stage.width,
      height: _stage.height
    };
    var _feedArea = {
      x: groupX + _stage.width + gap,
      y: 0,
      width: stripWidth,
      height: container.height
    };
    var _tiles = placeFeedGrid(_feedArea, _plan, gap);
    return {
      orientation: orientation,
      stage: _stageRect,
      feedArea: _feedArea,
      feedGrid: _objectSpread(_objectSpread({}, gridResultFromPlan(_plan)), {}, {
        tiles: _tiles
      })
    };
  }

  // VERTICAL: stage on top, strip on the bottom; reserve strip height.
  var stageBoxHeight = Math.max(1, container.height - MIN_FEED_AREA_HEIGHT - gap);
  var stage = fitAspectInBox(container.width, stageBoxHeight, stageAspect);
  var leftoverHeight = container.height - stage.height - gap;
  var plan = planFeedGrid({
    width: container.width,
    height: leftoverHeight
  }, feedCount, {
    gap: gap,
    maxVisible: maxVisible,
    minWidth: minWidth
  });
  var content = planContentSize(plan, gap);
  var stripHeight = Math.max(content.height, MIN_FEED_AREA_HEIGHT);
  var groupHeight = stage.height + gap + stripHeight;
  var groupY = Math.max(0, (container.height - groupHeight) / 2);
  var stageRect = {
    x: (container.width - stage.width) / 2,
    y: groupY,
    width: stage.width,
    height: stage.height
  };
  var feedArea = {
    x: 0,
    y: groupY + stage.height + gap,
    width: container.width,
    height: stripHeight
  };
  var tiles = placeFeedGrid(feedArea, plan, gap);
  return {
    orientation: orientation,
    stage: stageRect,
    feedArea: feedArea,
    feedGrid: _objectSpread(_objectSpread({}, gridResultFromPlan(plan)), {}, {
      tiles: tiles
    })
  };
};
var gridResultFromPlan = function gridResultFromPlan(plan) {
  return {
    cols: plan.cols,
    rows: plan.rows,
    tileWidth: plan.tileWidth,
    tileHeight: plan.tileHeight,
    tileAspect: plan.tileAspect,
    visibleCount: plan.visibleCount,
    overflowCount: plan.overflowCount
  };
};